import { createElement } from 'react'
/**
 * ConditionalWrapper
 *
 * A Higher order component to encapsulate the wrapping of modules based on a condition
 *
 * @example
 *  <ConditionalWrapper
 *    condition={shouldWrapWithcontainer === true}
 *    wrapper={Container}
 *    otherwise={Fragment} />
 *
 * @param {Object} props - The component properies.
 * @param {Boolean} props.condition - The condition to render the component based on
 * @param {any} props.wrapper - The wrapper component
 * @param {any} [props.otherwise] - The alternative wrapper, defaults to just children
 *
 * @returns {*} MaybeWrappedComponent
 */
export const ConditionalWrapper = ({ condition, wrapper, otherwise, children, ...rest }) =>
  condition
    ? createElement(wrapper, rest, children)
    : otherwise
    ? createElement(otherwise, rest, children)
    : children
